import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoiginImage from '../assets/images/login_image.png';
import Logo from '../assets/images/logo_image.png';
import { ValidateLogin } from '../assets/validation';
import AuthAction from '../store/actions/AuthAction';

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loggedIn } = useSelector((state) => state.authentication);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (loggedIn) {
      navigate('/dashboard');
    }
  }, [loggedIn, navigate]);

  return (
    <Box className="invoiceAppLoginWrap">
      <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
          <Box className="loginLeftBg">
            <img src={LoiginImage} alt="Login" />
          </Box>
        </Grid>
        <Grid item xs={6} md={6}>
          <Box className="loginRightForm">
            <Box
              className="loginFormWrap"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
              }}
            >
              <Formik
                initialValues={{
                  email: '',
                  password: ''
                }}
                validationSchema={ValidateLogin}
                onSubmit={(values, { setErrors, setSubmitting }) => {
                  const payload = {
                    email: values.email.trim().toLowerCase(),
                    password: values.password
                  };
                  dispatch(AuthAction.login(payload, setErrors, setSubmitting));
                }}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting
                }) => (
                  <form onSubmit={handleSubmit}>
                    <img src={Logo} alt="Logo" />
                    <Box className="logninInner">
                      <Typography variant="h3" gutterBottom component="" mb={2}>
                        Login
                      </Typography>
                      {/* <Typography
                        variant="body1"
                        align="center"
                        className="subtitle"
                        component="p"
                        mb={2}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                        tempor incididunt ut labore et dolore magna aliqua.
                      </Typography> */}
                      <Paper elevation={0} sx={{ background: 'none' }}>
                        <TextField
                          error={errors.email && touched.email}
                          label="Email ID"
                          placeholder="Enter Email ID"
                          fullWidth
                          name="email"
                          value={values.email}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          helperText={errors.email && touched.email && errors.email}
                          margin="normal"
                          variant="outlined"
                          required={false}
                          InputLabelProps={{ required: true }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                <IconButton
                                  aria-label="email field"
                                  edge="end"
                                  tabIndex={-1}
                                  disableRipple
                                  sx={{
                                    bgcolor: 'secondary.main',
                                    cursor: 'default',
                                    '&:hover': { bgcolor: 'secondary.main' }
                                  }}
                                >
                                  <i className="icon-mail" />
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                        />
                        <TextField
                          id="filled-password-input"
                          fullWidth
                          variant="outlined"
                          label="Password"
                          name="password"
                          type={showPassword ? 'text' : 'password'}
                          margin="normal"
                          placeholder="Enter Password"
                          error={errors.password && touched.password}
                          value={values.password}
                          // onChange={handleChange}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          helperText={errors.password && touched.password && errors.password}
                          required={false}
                          InputLabelProps={{ required: true }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                <IconButton
                                  aria-label={showPassword ? 'hide password' : 'show password'}
                                  edge="end"
                                  onClick={() => setShowPassword((s) => !s)}
                                  onMouseDown={(e) => e.preventDefault()}
                                  sx={{
                                    bgcolor: 'secondary.main',
                                    '&:hover': { bgcolor: 'secondary.dark' }
                                  }}
                                >
                                  <i className="icon-password" />
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                        />
                        <Typography
                          className="forgetPasswordLink"
                          variant="body1"
                          mt={2}
                          align="right"
                          sx={{
                            color: 'text.main',
                            opacity: '1 !important'
                          }}
                        >
                          Forgot Password? <Link to="/forget-password">Click Here</Link>
                        </Typography>
                        <Button
                          type="submit"
                          className="submit_btn"
                          variant="contained"
                          sx={{ mt: 3, mb: 1 }}
                          fullWidth
                          color="secondary"
                          size="large"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? <CircularProgress size={20} /> : 'Login'}
                        </Button>
                      </Paper>
                    </Box>
                  </form>
                )}
              </Formik>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Login;
